import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import {
    AllocationOverviewConfirmationCheck,
    Overview,
    SimulationOverview,
    MissingPartDetails,
} from "src/state/overview/state-models/overview-data";
import { Apollo, gql } from "apollo-angular";

@Injectable({
    providedIn: "root",
})
export class OverviewApiService {
    constructor(
        private http: HttpClient,
        private apollo: Apollo,
    ) {}

    GetByComponents(): Observable<Overview[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/byComponentUnit`;
        return this.http.get<Overview[]>(url);
    }

    GetByFinalAssembly(): Observable<Overview[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/byFinalAssemblyUnit`;
        return this.http.get<Overview[]>(url);
    }

    GetByConsolidation(): Observable<Overview[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/byConsolidationUnit`;
        return this.http.get<Overview[]>(url);
    }
    GetSimulation(): Observable<SimulationOverview> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/bySimulation`;
        return this.http.get<SimulationOverview>(url);
    }

    GetSimulationMissingPart(
        from: string,
        to: string,
        marketId: number,
        slaMarketId: number,
    ): Observable<MissingPartDetails> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/bySimulationMissingPart`;
        const reqData = {
            FromDate: from,
            ToDate: to,
            MarketId: marketId,
            SlaMarketId: slaMarketId,
        };
        return this.http.get<MissingPartDetails>(url, { params: reqData });
    }

    SaveAllocationOverviewConfirmationCheck(
        payload: AllocationOverviewConfirmationCheck,
    ) {
        const mutation = `
        mutation saveAllocationOverviewConfirmationCheck($payload: AllocationOverviewConfirmationCheckInput!){
            allocationOverviewConfirmationCheck{
                saveAllocationOverviewConfirmationCheck(payload: $payload)
                {
                    scaniaUnitId
                    updatedBy
                    isCompleted
                }
            }
        }`;
        return this.apollo
            .mutate({
                mutation: gql(mutation),
                variables: { payload },
            })
            .toPromise();
    }
}
